export const DOCUMENT_TYPE_LOGIN_FRONTPAGE = 'login-frontpage';
